import { useRef, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface StatusIconPopoverProps {
  icon: ReactNode;
  title: string;
  description: string;
}

export function StatusIconPopover({ icon, title, description }: StatusIconPopoverProps) {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const triggerRef = useRef<HTMLSpanElement>(null);
  const hideTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const show = () => {
    if (hideTimer.current) clearTimeout(hideTimer.current);
    if (triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setPos({ top: rect.bottom + 6, left: rect.left });
    }
    setOpen(true);
  };

  const hide = () => {
    hideTimer.current = setTimeout(() => setOpen(false), 100);
  };

  return (
    <>
      <span
        ref={triggerRef}
        onMouseEnter={show}
        onMouseLeave={hide}
        style={{ display: 'inline-flex' }}
      >
        {icon}
      </span>
      {open && createPortal(
        <div
          onMouseEnter={() => { if (hideTimer.current) clearTimeout(hideTimer.current); }}
          onMouseLeave={hide}
          style={{ position: 'fixed', top: pos.top, left: pos.left, zIndex: 9999 }}
          className="bg-white border border-ggc-border-gray rounded-md shadow-ggc-lg p-3 min-w-[180px] max-w-[240px]"
        >
          <div className="font-semibold text-sm text-ggc-text-primary mb-1">{title}</div>
          <div className="text-xs text-ggc-text-gray leading-relaxed">{description}</div>
        </div>,
        document.body
      )}
    </>
  );
}
